import React from "react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Data
import data from "../../../data/sideProjects.json";

// Components
import SearchBar from "../../Common/SearchBar/SearchBar";
import Tag from "../../Common/Tag/Tag";
import Magnetic from "../../Common/Magnetic/Magnetic";

// SCSS
import "./SideProjectWindow.scss";

const SideProjectWindow = ({ setHoveredElement }) => {
  // Search
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = data.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    const titleMatch = item.title.toLowerCase().includes(lowerSearch);
    const tagMatch = item.tags.some((tag) =>
      tag.toLowerCase().includes(lowerSearch),
    );

    return titleMatch || tagMatch;
  });

  return (
    <div className="SideProjectWindow">
      <section className="Search">
        <div className="Search__Wrapper">
          <SearchBar value={searchTerm} onChange={setSearchTerm} />
        </div>
      </section>
      <AnimatePresence mode="popLayout">
        {filteredData.length > 0 ? (
          filteredData.map((item) => (
            <motion.section
              className="Project"
              key={item.id}
              layout
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{
                opacity: 0,
                transition: { duration: 0.15 },
              }}
              transition={{
                layout: { type: "spring", stiffness: 200, damping: 25 },
                opacity: { duration: 0.2 },
              }}
            >
              <Magnetic
                setHoveredElement={setHoveredElement}
                as="a"
                href={item.link}
                target="_blank"
                rel="noreferrer"
                className="Project__Wrapper"
              >
                <div className="Project__Image">
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="Project__Image-Tumbnail"
                  />
                  <img
                    src={item.image}
                    alt={item.title}
                    className="Project__Image-Preview"
                  />
                </div>
                <div className="Project__Detail">
                  <div className="Project__Title">
                    <h3 className="Project__Title-Text">{item.title}</h3>
                    <span className="Project__Title-Date">{item.date}</span>
                  </div>
                  <div className="Project__Desc">
                    <p className="Project__Desc-Text">{item.desc}</p>
                  </div>
                  <div className="Project__Tag">
                    {item.tags.map((tag, index) => (
                      <Tag key={tag} text={tag} />
                    ))}
                  </div>
                </div>
              </Magnetic>
            </motion.section>
          ))
        ) : (
          <section className="NoResult">
            <div className="NoResult__Wrapper">
              <p className="NoResult-Text">No Result!</p>
            </div>
          </section>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SideProjectWindow;
